import React, { useState } from "react";
import QueryBuilder from "../QueryBuilder/Querybuilder";
import logo from "../../assets/logo.png";
import { Button, Modal, Form, Input, Select, message, Row, Col } from "antd";
const AddItem = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const { Option } = Select;
  const onFinish = (values) => {
    console.log("Form Values:", values);
    handleAddAssigne(values);
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
    form.resetFields();
  };
  const handleAddAssigne = async (values) => {
    debugger;
    const dataToSend = {
      name: values.name,
      field_type: values.fieldType,
      short_code: values.shortCode,
    };

    try {
      const response = await fetch("/api/portal/pms/add_pms_item", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        message.success("Source added successfully");
        setModalVisible(false);
        form.resetFields();
      } else {
        message.error("Failed to add source");
      }
    } catch (error) {
      message.error("Error adding source");
      console.error("Error:", error);
    }
  };
  return (
    <div>
      <Modal
        open={modalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
        title="Public Grievance Form"
        width={1000}
        style={{ top: 20, left: "6%" }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            style={{ width: 60, marginRight: 20 }}
            alt="Pulse Logo"
          />
          <h2 style={{ margin: 0 }}>Janasena</h2>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: 20 }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="fieldType"
                label="Field Type"
                rules={[
                  { required: true, message: "Please select a field type" },
                ]}
              >
                <Select placeholder="Select field type">
                  <Option value="source">Source</Option>
                  <Option value="category">Category</Option>
                  <Option value="type_of_petition">Type Of Petition</Option>
                  <Option value="Priortiy">Priortiy</Option>
                  <Option value="Call Notes">Call Notes</Option>
                  <Option value="Feedback_Type">Feedback Type</Option>
                  <Option value="petitioner_Type">Petitioner Type</Option>
                  <Option value="solution_Type">Solution Type</Option>
                  <Option value="status">Status</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter the name" }]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="shortCode" label="Short Code">
                <Input placeholder="Enter short code" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <QueryBuilder
        title={"Form Fields Dropdown"}
        Headername={"/api/portal/reports/pms/getTablemetadata/54"}
        Rulesdata={"/api/portal/reports/pms/getFilters/54"}
        Databyquery={"/api/portal/reports/pms/getDatabyquery/54"}
        additem={true}
        additembtn={showModal}
      />
    </div>
  );
};

export default AddItem;
